import React from "react";
import "./Header.css";

const Header = ({ className, size, children }) => {
	return <h1 className={`Header ${size} ${className}`}>{children}</h1>;
};

export default Header;
